import { z } from "zod";

// Mirrors registerSchema for the fields the profile editor exposes. Email is
// read-only (separate flow), region is read-only (§D.3), so they're not here.
export const profileFormSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, "First name is required")
    .max(30, "First name must be 30 characters or fewer"),
  lastName: z
    .string()
    .trim()
    .min(1, "Last name is required")
    .max(30, "Last name must be 30 characters or fewer"),
  phone: z
    .string()
    .trim()
    .min(1, "Telephone number is required")
    .max(32, "Phone number must be 32 characters or fewer")
    .regex(
      /^\+?[\d\s\-().]{7,20}$/,
      "Enter a valid phone number (e.g. +1 555 123 4567)",
    ),
  companyName: z
    .string()
    .trim()
    .min(1, "Company name is required")
    .max(100, "Company name must be 100 characters or fewer"),
  companyAddress: z
    .string()
    .trim()
    .min(1, "Company address is required")
    .max(500, "Company address must be 500 characters or fewer"),
  departmentId: z
    .union([z.literal(""), z.coerce.number().int().positive()])
    .refine((v) => typeof v === "number" && v > 0, {
      message: "Please select a department",
    }),
});

export type ProfileFormData = z.infer<typeof profileFormSchema>;
